import { render, staticRenderFns } from "./ReceitasTestar.vue?vue&type=template&id=d11e3612&"
import script from "./ReceitasTestar.vue?vue&type=script&lang=js&"
export * from "./ReceitasTestar.vue?vue&type=script&lang=js&"
import style0 from "./ReceitasTestar.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports